// extracted by mini-css-extract-plugin
module.exports = {"errorTitle":"ChartStatus_errorTitle__28YkC","table":"ChartStatus_table__1LGmM"};